import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import {
  ExtractCapabilityRequirementsBodySchema,
  ExtractCapabilityRequirementsResponseDataSchema,
} from "schema"
import z from "zod"

type Response = {
  data: z.infer<typeof ExtractCapabilityRequirementsResponseDataSchema>
}

export function useExtractCapabilityRequirementsMutation() {
  return useMutation({
    mutationFn: async (data: z.input<typeof ExtractCapabilityRequirementsBodySchema>) => {
      const response = await axios.post<Response>(
        "/capabilities/extract-capability-requirements",
        data,
      )
      return response.data.data
    },
  })
}
